var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isButtonActive)?_c('div',[_vm._v(" Belge Yükleme işlemi için partner.trendyol.com'u kullanınız. ")]):_c('div',[_vm._v(" Belge onay sürecinde ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }